import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z","key":"svg-0"}],["path",{"d":"M16 3v4","key":"svg-1"}],["path",{"d":"M8 3v4","key":"svg-2"}],["path",{"d":"M4 11h16","key":"svg-3"}],["path",{"d":"M8 14v4","key":"svg-4"}],["path",{"d":"M12 14v4","key":"svg-5"}],["path",{"d":"M16 14v4","key":"svg-6"}]]

const IconCalendarMonth = createReactComponent('outline', 'calendar-month', 'CalendarMonth', __iconNode);

export default IconCalendarMonth;